/**
 * Tributo impresso por item no Orçamento e no Pedido de Venda (§11.2 e §11.3).
 * Espelha db_vendas.tipo_imposto_impressao: as configurações guardam a lista de ids escolhidos e
 * a folha imprime só eles, na ordem do catálogo.
 */
export enum TipoImpostoImpressaoEnum {
    AliquotaIcms = 1,
    ValorIcms = 2,
    AliquotaIcmsSt = 3,
    ValorIcmsSt = 4,
    Mva = 5,
    AliquotaFcp = 6,
    ValorFcp = 7,
    AliquotaFcpSt = 8,
    ValorFcpSt = 9,
    AliquotaIpi = 10,
    ValorIpi = 11,
    AliquotaPis = 12,
    ValorPis = 13,
    AliquotaCofins = 14,
    ValorCofins = 15,
    CstIbsCbs = 16,
    ClassificacaoTributaria = 17,
    BaseIbsCbs = 18,
    IbsUf = 19,
    IbsMunicipio = 20,
    IbsTotal = 21,
    Cbs = 22,
    Cfop = 23,
}
